import './App.css';
import TextEditor from './components/TextEditor';

function App() {
  return (
    <div className="App">
      <TextEditor/>
    </div>
  );
}

export default App;
